import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Fragment, memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { DateInput } from '../DateInput';
import { Icon } from '../Icon';
import { TextInput, } from '../TextInput';
const amex = (match) => {
    if (parseInt(match.substring(0, 2), 10) === 34
        || parseInt(match.substring(0, 2), 10) === 37) {
        return true;
    }
    return false;
};
const cardReplacer = (match, $1, $2, $3, $4) => (amex(match)
    ? `${$1} ${$2.length === 6 ? `${$2} ` : $2}${$3}`
    : `${$1} ${$2.length === 4 ? `${$2} ` : $2}${$3.length === 4 ? `${$3} ` : $3}${$4}`);
const cardRe = (match) => (amex(match)
    ? /(\d{4})(\d{0,6})(\d{0,5})/gi
    : /(\d{4})(\d{0,4})(\d{0,4})(\d{0,4})/gi);
const cardMaxLength = (match) => (amex(match)
    ? 17
    : 19);
const cvvMaxLength = (match) => (amex(match)
    ? 4
    : 3);
const formatNumber = (event, { maxLength, onChange, re, replacer, stateValue, }) => {
    let { value, } = event.target;
    // non character key pressed let backspace work
    if (event.type !== 'blur' && value.length <= stateValue.length) {
        onChange(event);
        return;
    }
    // maxLength hit, do nothing
    if (value.length > maxLength) {
        return;
    }
    value = (value
        .replace(/\D/gi, '')
        .replace(re, replacer));
    event.target.value = value;
    onChange(event);
};
const defaultProps = {
    className: '',
    onBlur: () => { },
};
const CreditCardInput = ({ cardNumberProps, className = defaultProps.className, cvvProps, expDateProps, onBlur = defaultProps.onBlur, onChange, }) => {
    const cardNumberChange = (event) => {
        formatNumber(event, {
            maxLength: cardMaxLength(event.target.value),
            onChange,
            re: cardRe(event.target.value),
            replacer: cardReplacer,
            stateValue: cardNumberProps.value,
        });
    };
    const cvvChange = (event) => {
        formatNumber(event, {
            maxLength: cvvMaxLength(cardNumberProps.value),
            onChange,
            stateValue: cvvProps.value,
        });
    };
    const error = cardNumberProps.error || expDateProps.error || cvvProps.error;
    const errorStyles = (error
        && css `
      border-color: ${theme.colors.negative800};
    `);
    const focusStyles = css `
    &:focus-within {
      box-shadow: none;
      border-color: ${error ? theme.colors.negative800 : theme.colors.gray400};
    }
  `;
    const iconContainerStyles = css `
    flex: 0 0 ${styleUtils.rem(48)};
    position: absolute;
    right: ${theme.spacing.x3};
    top: ${theme.spacing.x3};
    color: ${theme.colors.gray500};
  `;
    return (_jsx(Fragment, { children: _jsxs("div", Object.assign({ className: className, css: css `
          display: flex;
          position: relative;
        ` }, { children: [_jsx("div", Object.assign({ css: css `flex: 1 1 ${styleUtils.rem(256)};` }, { children: _jsx(TextInput, { autoComplete: "cc-number", css: css `
                border-right: none;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                ${errorStyles}
                ${focusStyles}
              `, disabled: cardNumberProps.disabled, error: cardNumberProps.error, inputMode: "numeric", label: "Card Number", name: cardNumberProps.name || 'cardnumber', onBlur: onBlur, onChange: cardNumberChange, pattern: "(\\d{4})\\s(\\d{4})\\s(\\d{4})\\s(\\d{4})|(\\d{4})\\s(\\d{6})\\s(\\d{5})", touched: cardNumberProps.touched, type: "tel", value: cardNumberProps.value }) })), _jsx("div", Object.assign({ css: css `flex: 1 1 ${styleUtils.rem(120)};` }, { children: _jsx(DateInput, { autoComplete: "cc-exp", css: css `
                border-right: none;
                border-left: none;
                border-radius: 0;
                ${errorStyles}
                ${focusStyles}
              `, dateFormat: "MMYYYY", disabled: expDateProps.disabled, error: expDateProps.error, inputMode: "numeric", label: "MM/YYYY", name: expDateProps.name || 'cc-exp', onBlur: onBlur, onChange: onChange, touched: expDateProps.touched, type: "tel", value: expDateProps.value }) })), _jsxs("div", Object.assign({ css: css `flex: 1 1 ${styleUtils.rem(180)};` }, { children: [_jsx(TextInput, { autoComplete: "cc-csc", css: css `
                border-left: none;
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                ${errorStyles}
                ${focusStyles}
              `, disabled: cvvProps.disabled, error: cvvProps.error, inputMode: "numeric", label: "CVV", name: cvvProps.name || 'cvc', onBlur: onBlur, onChange: cvvChange, touched: cvvProps.touched, type: "tel", value: cvvProps.value }), _jsx("div", Object.assign({ css: iconContainerStyles }, { children: _jsx(Icon, { type: "lock" }) }))] }))] })) }));
};
const MemoizedCreditCardInput = memo(CreditCardInput);
export { MemoizedCreditCardInput as CreditCardInput };
// MC-1068 Temporary hack for Storybook.
export default CreditCardInput;
